/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface JumboGetwizercompanyGetWizerCompanyResult
 */
export interface JumboGetwizercompanyGetWizerCompanyResult {
    /**
     * 
     * @type {boolean}
     * @memberof JumboGetwizercompanyGetWizerCompanyResult
     */
    isAdmin?: boolean;
    /**
     * 
     * @type {string}
     * @memberof JumboGetwizercompanyGetWizerCompanyResult
     */
    wizerAdminTrainingsURL?: string;
    /**
     * 
     * @type {string}
     * @memberof JumboGetwizercompanyGetWizerCompanyResult
     */
    wizerAdminUsersURL?: string;
    /**
     * 
     * @type {string}
     * @memberof JumboGetwizercompanyGetWizerCompanyResult
     */
    wizerCompanyID?: string;
    /**
     * 
     * @type {string}
     * @memberof JumboGetwizercompanyGetWizerCompanyResult
     */
    wizerCompanyName?: string;
}

/**
 * Check if a given object implements the JumboGetwizercompanyGetWizerCompanyResult interface.
 */
export function instanceOfJumboGetwizercompanyGetWizerCompanyResult(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function JumboGetwizercompanyGetWizerCompanyResultFromJSON(json: any): JumboGetwizercompanyGetWizerCompanyResult {
    return JumboGetwizercompanyGetWizerCompanyResultFromJSONTyped(json, false);
}

export function JumboGetwizercompanyGetWizerCompanyResultFromJSONTyped(json: any, ignoreDiscriminator: boolean): JumboGetwizercompanyGetWizerCompanyResult {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'isAdmin': !exists(json, 'isAdmin') ? undefined : json['isAdmin'],
        'wizerAdminTrainingsURL': !exists(json, 'wizerAdminTrainingsURL') ? undefined : json['wizerAdminTrainingsURL'],
        'wizerAdminUsersURL': !exists(json, 'wizerAdminUsersURL') ? undefined : json['wizerAdminUsersURL'],
        'wizerCompanyID': !exists(json, 'wizerCompanyID') ? undefined : json['wizerCompanyID'],
        'wizerCompanyName': !exists(json, 'wizerCompanyName') ? undefined : json['wizerCompanyName'],
    };
}

export function JumboGetwizercompanyGetWizerCompanyResultToJSON(value?: JumboGetwizercompanyGetWizerCompanyResult | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'isAdmin': value.isAdmin,
        'wizerAdminTrainingsURL': value.wizerAdminTrainingsURL,
        'wizerAdminUsersURL': value.wizerAdminUsersURL,
        'wizerCompanyID': value.wizerCompanyID,
        'wizerCompanyName': value.wizerCompanyName,
    };
}

